import {
  DndContext,
  KeyboardSensor,
  PointerSensor,
  closestCenter,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  arrayMove,
  rectSortingStrategy,
  sortableKeyboardCoordinates,
} from "@dnd-kit/sortable";
import PropTypes from "prop-types";
import * as React from "react";
import CharacterTile from "./CharacterTile";
import PendingTile from "./PendingTile";
import css from "./ShopImagesEditor.module.css";

export default function CharacterGrid({
  characters,
  pending,
  onAction,
  onReorder,
  onRetry,
  onDiscard,
}) {
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );
  const imageIds = characters.map((image) => image.imageId);

  const handleDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) return;

    onReorder(
      arrayMove(
        imageIds,
        imageIds.indexOf(active.id),
        imageIds.indexOf(over.id),
      ),
      active.id,
    );
  };

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <SortableContext items={imageIds} strategy={rectSortingStrategy}>
        <ul className={css.grid} aria-label="Character images">
          {characters.map((image, index) => (
            <CharacterTile
              key={image.imageId}
              image={image}
              isFirst={index === 0}
              isLast={index === characters.length - 1}
              onAction={onAction}
            />
          ))}
          {pending.map((item) => (
            <PendingTile
              key={item.id}
              item={item}
              onRetry={onRetry}
              onDiscard={onDiscard}
            />
          ))}
        </ul>
      </SortableContext>
    </DndContext>
  );
}

CharacterGrid.propTypes = {
  characters: PropTypes.arrayOf(PropTypes.object).isRequired,
  pending: PropTypes.arrayOf(PropTypes.object).isRequired,
  onAction: PropTypes.func.isRequired,
  onReorder: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
};
